var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "x-office-calendar-svgrepo-com",
    d: "M6.571,1V2.857A5.6,5.6,0,0,0,1,8.429v13A5.6,5.6,0,0,0,6.571,27H21.429A5.6,5.6,0,0,0,27,21.429v-13a5.6,5.6,0,0,0-5.571-5.571V1H17.714V2.857H10.286V1Zm0,9.286H21.429a1.851,1.851,0,0,1,1.857,1.857v9.286c0,1.059-.82,1.647-1.857,1.857H6.571a1.816,1.816,0,0,1-1.857-1.857V12.143A1.851,1.851,0,0,1,6.571,10.286Zm5.571,1.857V14h3.714V12.143Zm5.571,0V14h3.714V12.143ZM6.571,15.857v1.857h3.714V15.857Zm5.571,0v1.857h3.714V15.857Zm5.571,0v1.857h3.714V15.857ZM6.571,19.571v1.857h3.714V19.571Zm5.571,0v1.857h3.714V19.571Zm5.571,0v1.857h3.714V19.571Zm0,0",
    transform: "translate(-1 -1)",
    fill: "#081831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMobileIcon);
export default __webpack_public_path__ + "static/media/calendarMobileIcon.b33b58289005e584a0d0d682788e1006.svg";
export { ForwardRef as ReactComponent };